import React, { useRef, useState } from "react";
import { toast } from "sonner";
import api, { apiError, mediaUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ImagePlus, Loader2, Trash2, Crop } from "lucide-react";
import { ImageCropDialog } from "@/components/ImageCropDialog";

export async function uploadImage(blob, name = "image.jpg") {
  const fd = new FormData();
  fd.append("file", blob, name);
  const { data } = await api.post("/uploads/image", fd);
  return data.url;
}

export const ImageField = ({ value, onChange, label = "Снимка", testid = "product-photo" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [crop, setCrop] = useState(null);

  const pick = (file) => {
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) return toast.error("Снимката е твърде голяма (макс. 8 MB)");
    setCrop({ src: URL.createObjectURL(file), type: file.type });
    if (ref.current) ref.current.value = "";
  };
  const done = async (blob, err) => {
    const type = crop?.type;
    setCrop(null);
    if (err || !blob) return toast.error("Снимката не може да бъде изрязана");
    setBusy(true);
    try { onChange(await uploadImage(blob, type === "image/png" ? "image.png" : "image.jpg")); toast.success("Снимката е качена"); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div>
      <Label className="text-xs">{label}</Label>
      <div className="flex items-center gap-3 mt-1">
        <div className="w-20 h-20 rounded-xl bg-cream-muted overflow-hidden flex items-center justify-center shrink-0">
          {value ? <img src={mediaUrl(value)} alt="" className="w-full h-full object-cover" data-testid={`${testid}-preview`} /> : <ImagePlus className="w-6 h-6 text-forest/40" />}
        </div>
        <div className="flex flex-col gap-1.5">
          <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => pick(e.target.files?.[0])} data-testid={`${testid}-input`} />
          <Button type="button" variant="outline" size="sm" disabled={busy} onClick={() => ref.current?.click()} className="rounded-xl gap-2" data-testid={`${testid}-upload-btn`}>
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ImagePlus className="w-4 h-4" />}{value ? "Смени" : "Качи"}
          </Button>
          {value && (
            <div className="flex gap-1">
              <Button type="button" variant="ghost" size="sm" onClick={() => setCrop({ src: mediaUrl(value), type: "image/jpeg" })} className="rounded-xl gap-1 px-2" data-testid={`${testid}-crop-btn`}><Crop className="w-4 h-4" /> Изрежи</Button>
              <Button type="button" variant="ghost" size="sm" onClick={() => onChange("")} className="rounded-xl gap-1 px-2 text-destructive" data-testid={`${testid}-remove-btn`}><Trash2 className="w-4 h-4" /></Button>
            </div>
          )}
        </div>
      </div>
      <ImageCropDialog src={crop?.src} type={crop?.type} onCancel={() => setCrop(null)} onDone={done} />
    </div>
  );
};
